import { role } from '../api/entities';

export const actions = {
  listRole: 'LIST_ROLE',
};

export function getRoles() {
  return role.list(actions.listRole, null, null, true);
}

const INITIAL_STATE = {
  roles: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.listRole:
      return {
        ...state,
        roles: action.body ? action.body._items : state.roles,
      };
    default:
      return {
        ...state,
      };
  }
}
